import { FC } from 'react';

import { CompanyProfile } from 'models';

import { OrganizationBadges, useMemberOrganizations } from 'components/badges/OrganizationBadges';
import { Section } from 'components/section/Section';

const Memberships: FC<{ company: CompanyProfile }> = ({ company }) => {
    const memberOrganizations = useMemberOrganizations(company.compliance);

    if (!memberOrganizations.length) return null;

    return (
        <Section title="Memberships" id="memberships">
            <OrganizationBadges organizations={memberOrganizations} />
        </Section>
    );
};

export { Memberships };
